import ReactDOM from 'react-dom'
import { Provider } from 'mobx-react'
import { ThemeProvider } from 'styled-components'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import ScrollToTop from 'components/ScrollToTop'
import theme from 'theme'
import store from 'stores'

import './assets'
import App from './App'

ReactDOM.render(
  <Provider {...store}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <ScrollToTop>
          <Routes>
            <Route path="*" element={<App />} />
          </Routes>
        </ScrollToTop>
      </BrowserRouter>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
)

// reportWebVitals()
